'use client';
import { Slot } from '@radix-ui/react-slot';
import React__default, { forwardRef } from 'react';
import { createPortal } from 'react-dom';

const PORTAL_NAME = "Portal";
const Portal = forwardRef(
  ({ container = document?.body, asChild, ...props }, forwardedRef) => {
    const Component = asChild ? Slot : "div";
    return container ? createPortal(
      /* @__PURE__ */ React__default.createElement(Component, {
        "data-liveblocks-portal": "",
        ...props,
        ref: forwardedRef
      }),
      container
    ) : null;
  }
);
if (process.env.NODE_ENV !== "production") {
  Portal.displayName = PORTAL_NAME;
}

export { Portal };
//# sourceMappingURL=Portal.mjs.map
